import React from "react";
import Tooltip from "@gfg/ui-v2/components/tooltip";

export default function withTooltip<T>(label: React.ReactNode, Component: React.ComponentType<T>) {
  return function ComponentWithTooltip(props: JSX.IntrinsicAttributes & T & { children?: React.ReactNode }) {
    return <Tooltip triggerElement={<Component {...props} />}>{label}</Tooltip>;
  };
}
